import {
  GET_JOB_DETAILS_PAGE_SELECTED_VIEW_ERROR,
  GET_JOB_DETAILS_PAGE_SELECTED_VIEW_START,
  GET_JOB_DETAILS_PAGE_SELECTED_VIEW_SUCCESS,
  GET_JOB_DETAILS_PAGE_VIEWS_ERROR,
  GET_JOB_DETAILS_PAGE_VIEWS_START,
  GET_JOB_DETAILS_PAGE_VIEWS_SUCCESS,
  GET_JOB_DETAILS_ERROR,
  GET_JOB_DETAILS_START,
  GET_JOB_DETAILS_SUCCESS,
  SET_JOB_DETAILS_SELECTED_VIEW_ERROR,
  SET_JOB_DETAILS_SELECTED_VIEW_START,
  SET_JOB_DETAILS_SELECTED_VIEW_SUCCESS
} from './JobDetailsActions';

const initialState = {
  jobDetailsSelectedView: {
    error: null,
    loaded: false,
    loading: false,
    selectedViewPk: null,
    status: null
  },
  jobDetailsViews: {
    defaultViewId: null,
    error: null,
    loaded: false,
    loading: false,
    status: null,
    views: []
  },
  jobDetailsData: null,
  setJobDetailsSelectedView: {
    loading: false
  }
};

const JobDetailsReducer = function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_JOB_DETAILS_PAGE_SELECTED_VIEW_ERROR: {
      return {
        ...state,
        jobDetailsSelectedView: {
          error: action.message,
          loaded: true,
          loading: false,
          selectedViewPk: null,
          status: action.status
        }
      };
    }
    case GET_JOB_DETAILS_PAGE_SELECTED_VIEW_START: {
      return {
        ...state,
        jobDetailsSelectedView: {
          error: null,
          loaded: false,
          loading: true,
          selectedViewPk: state.jobDetailsSelectedView?.selectedViewPk,
          status: null
        }
      };
    }
    case GET_JOB_DETAILS_PAGE_SELECTED_VIEW_SUCCESS: {
      return {
        ...state,
        jobDetailsSelectedView: {
          error: null,
          loaded: true,
          loading: false,
          selectedViewPk: action.selectedViewPk,
          status: action.status || 200
        }
      };
    }
    case GET_JOB_DETAILS_PAGE_VIEWS_ERROR: {
      return {
        ...state,
        jobDetailsViews: {
          defaultViewId: null,
          error: action.message,
          loaded: true,
          loading: false,
          status: action.status || 500,
          views: []
        }
      };
    }
    case GET_JOB_DETAILS_PAGE_VIEWS_START: {
      return {
        ...state,
        jobDetailsViews: {
          defaultViewId: null,
          error: null,
          loaded: false,
          loading: true,
          status: null,
          views: state.jobDetailsViews?.views
        }
      };
    }
    case GET_JOB_DETAILS_PAGE_VIEWS_SUCCESS: {
      return {
        ...state,
        jobDetailsViews: {
          defaultViewId: action.defaultViewId,
          error: null,
          loaded: true,
          loading: false,
          status: action.status || 200,
          views: action.views
        }
      };
    }
    case GET_JOB_DETAILS_ERROR: {
      return {
        ...state,
        jobDetailsData: null,
        loaded: true,
        loading: false
      };
    }
    case GET_JOB_DETAILS_START: {
      return {
        ...state,
        loading: true
      };
    }
    case GET_JOB_DETAILS_SUCCESS: {
      return {
        ...state,
        jobDetailsData: action.jobDetailsData,
        loaded: true,
        loading: false
      };
    }
    case SET_JOB_DETAILS_SELECTED_VIEW_ERROR: {
      return {
        ...state,
        setJobDetailsSelectedView: {
          loading: false
        }
      };
    }
    case SET_JOB_DETAILS_SELECTED_VIEW_START: {
      return {
        ...state,
        setJobDetailsSelectedView: {
          loading: true
        }
      };
    }
    case SET_JOB_DETAILS_SELECTED_VIEW_SUCCESS: {
      return {
        ...state,
        setJobDetailsSelectedView: {
          loading: false
        },
        jobDetailsSelectedView: {
          error: null,
          loaded: true,
          loading: false,
          selectedViewPk: action.selectedViewPk,
          status: action.status || 200
        }
      };
    }
    default:
      return state;
  }
};

export default JobDetailsReducer;
